export enum InterviewSlotStatus {
	FREE = 'FREE',
	SCHEDULED = 'SCHEDULED',
	ATTENDED = 'ATTENDED',
	MISSED = 'MISSED',
	CANCELED = 'CANCELED'
}

export interface InterviewSlotAppointment {
	from: Date;
	to: Date;
}

export interface Interviewer {
	name: string;
	email: string;
}

export interface InterviewSlotDto {
	id?: string;
	appointment: InterviewSlotAppointment;
	interviewer: Interviewer;
	status: InterviewSlotStatus;
	location?: string;
	notes?: string;
	isOnline?: boolean;
}
